import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Header, List, ListItem, Placeholder, ScrollView } from '$uikit';
import { leaderboardActions, selectLeaderboard } from '$store/leaderboard';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';
import { format } from '$utils';
import { goTo } from '$navigation/helper';
import { LEADERBOARD } from '$shared/constants/pages';

export const LeaderboardsHistory: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const { history, historyLoadingStatus: loadingStatus } = useSelector(selectLeaderboard);

  const handleLoad = () => {
    dispatch(leaderboardActions.loadHistory());
  };

  useEffect(() => {
    handleLoad();
  }, []);

  function renderContent() {
    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          centered
          actions={<Button onClick={handleLoad}>{t('failed_button')}</Button>}
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (loadingStatus === 'loading' && !history.length) {
      return <Loader isWrapped />;
    }

    return (
      <div style={{ padding: '0 16px' }}>
        <List>
          {history.map((item) => {
            return (
              <ListItem
                key={item.id}
                chevron
                onClick={() => {
                  goTo(LEADERBOARD, {
                    id: item.id,
                  });
                }}
              >
                <span
                  style={{
                    fontWeight: 'normal',
                    color: 'var(--foreground-secondary)',
                    marginRight: 8,
                  }}
                >
                  #{item.id}
                </span>{' '}
                {format(item.date * 1000, 'MMM yyyy')}
              </ListItem>
            );
          })}
        </List>
      </div>
    );
  }

  return (
    <>
      <Header showBackButton>{t('leaderboards_history_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
